import { render } from "./legoDropHolder.vue?vue&type=template&id=0c3396c2"
import script from "./legoDropHolder.vue?vue&type=script&lang=js"
export * from "./legoDropHolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoDropdown/legoDropHolder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c3396c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c3396c2', __exports__)) {
    api.reload('0c3396c2', __exports__)
  }
  
  module.hot.accept("./legoDropHolder.vue?vue&type=template&id=0c3396c2", () => {
    api.rerender('0c3396c2', render)
  })

}


export default __exports__